export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const api = $fetch.create({
    baseURL: config.public.baseURL,
    credentials: 'include',

    onRequest({ options }) {
      options.headers = setupHeaders(options.headers)
    },

    onResponseError({ response }) {
      if ([404, 500].includes(response.status)) {
        showError({
          message: response._data.detail,
          statusCode: response.status,
        })
        return
      }
    },
  })

  return {
    provide: {
      api,
    },
  }
})
